import axios from 'axios' //导入axios读取接口
import store from '@/store/index.js'
import baseConfig from '@/config/base-config'

//读取数据接口
var http = (option) => {
	return new Promise((resolve, reject) => {
		let opt = option ? option : null;

		let opt_default = {
			isLoading: true, //是否加载loading
			isCloseLoading: true, //是否关闭Loading
			loadTitle: '数据加载中',
			url: '', //前缀不用写
			method: 'get', //接口类型
			header: {},
			data: {}, //data参数
			params: {}, //params参数
			dataType: 'json', //数据返回类型
			success: null, //成功回调函数
			successOther: null, //成功回调函数
			error: null, //失败回调函数
			complete: null //调用接口完回调函数
		};
		opt = opt ? Object.assign(opt_default, opt) : opt_default;
		opt.header['orgId'] = store.state.orgId || ''
		//headerData = headerData ? Object.assign(opt.headerData, headerData) : opt.headerData; //合并header参数
		//alert('加载axios'+JSON.stringify(headerData))
		axios({
			method: opt.method,
			url: baseConfig.APP_BASE_API + opt.url,
			headers: opt.header,
			data: opt.data,
			params: opt.params
		}).then((res) => {
			//alert('成功code:'+res.data.code)
			if (res.data.code == 200) {
				resolve(res.data);
			} else {
				reject(res);
			}
		}).catch((res) => {
			//alert('失败啊啊:'+res)
			reject(res)
		})
	})
}

//输出
export default http



// WEBPACK FOOTER //
// ./src/static/js/axios.js